import { mapAnswer } from "features/ConsultRequest/data/mappers";

export default function AnswerList({ answers = [] }) {
  return (
    <div>
      {answers.map((a, i) => {
        const { label, text } = mapAnswer(a);
        return (
          <div key={`${label}-${i}`} style={{ display: "flex", padding: "4px 0" }}>
            <span style={{ width: 180, color: "#5b667f" }}>{label}</span>
            <span>{text}</span>
          </div>
        );
      })}
    </div>
  );
}
